
import { Options, Vue } from 'vue-class-component'
import { Swiper, SwiperSlide } from 'swiper/vue';
import SwiperCore, {
  // 设置底部小圆点
  Pagination,
  // 设置两边的箭头
  Navigation,
  // 动画效果
  EffectCoverflow,
  // 自动播放
  Autoplay
} from 'swiper';

import "swiper/swiper-bundle.css"

SwiperCore.use([Pagination, Navigation, EffectCoverflow, Autoplay]);

import COVERAPP from '@/utils/COVERAPP'
import Config from '@/utils/config'


@Options({
  components: {
    Swiper,
    SwiperSlide
  },
  props: ['data'],
  methods: {
    dynamicLink(id) {
      if (COVERAPP.Attribute.isApp()) {
        return `${Config.APP_SCHEME_URL}/news?id=${ id }&flag=101`;
      } else {
        return `https://m.thecover.cn/topic_content.html?dynamic_id=` + id;
      }
    },
  },
})
export default class Topic extends Vue {}
